export default class NavigationFlyout {
  constructor($navigation) {
    this.$navigation = $navigation;
  }

  init() {
    this.$navigation.classList.add('navigation--flyout');
  }

  deinit() {
    this.$navigation.classList.remove('navigation--flyout');
  }
}
